import React, {useState} from "react";
import {
    darken,
    Dialog,
    DialogTitle,
    IconButton,
    lighten,
    List,
    ListItem,
    Slide,
    styled,
    Typography
} from "@mui/material";
import {THEME_CONFIG} from "../../../config";
import pleshDark from "../../../theme/pleshDark";
import {Close} from "@mui/icons-material";

const {poll, pollBorder, pollTextColor, borderRadius} = THEME_CONFIG

export default function ColorQuizQuestion({risposte, hideResult = false, answer, sendAnswer, isPoll}) {
    const RispostaStyled = styled(ListItem)({
        border: `2px solid ${pollBorder.default}`,
        borderRadius: borderRadius.default,
        background: poll.default,
        margin: '1rem 0',
        cursor: 'pointer',
        color: pollTextColor.default
    })

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogColor, setDialogColor] = useState("transparent");

    const Risposte = () => (
        risposte?.map((r, i) => (
            <RispostaStyled key={i} style={{
                width: '100%',
                background: r.color,
                border: THEME_CONFIG.borders.default !== 'none' ? `2px solid ${darken(r.color, 0.5)}` : 'none',
                color: pleshDark.palette.getContrastText(r.color || pleshDark.palette.primary.main),
            }} onClick={() => rispondi(r)}>
                <Typography variant={"h6"} fontWeight='400' textAlign={'center'} width={'100%'}>
                    {r.label}
                </Typography>
            </RispostaStyled>
        ))
    )

    const rispondi = (r) => {
        if(isPoll) {
            sendAnswer(r.label)
        } else {
            if(answer === '') {
                sendAnswer(r.label)
            }
        }
        setDialogColor(r.color);
        setOpenDialog(true);
    }

    return (
        <List>
            <Risposte/>
            <Dialog
              fullScreen
              open={openDialog}
              TransitionComponent={Slide}
              PaperProps={{
                  style: {
                      backgroundColor: dialogColor,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                  },
              }}
              //sx={{visibility: hideResult ? 'hidden' : 'visible'}}
            >
                <DialogTitle>
                    <IconButton onClick={() => {
                        setOpenDialog(false)
                    }}>
                        <Close/>
                    </IconButton>
                </DialogTitle>
            </Dialog>
        </List>
    )
}
